import * as apiPostRecipeCalculateV1 from 'api/recipe/PostRecipeCalculateV1';
import { IngredientType } from 'enums/ingredientType';
import { Optional } from 'functions/promiseExtensions';
import * as IngredientList from 'types/Recipe/Detail/ErpNew/IngredientList';
import { SegmentStatus } from 'types/Recipe/SegmentStatus';

import { IncorporationShare, relevanceType } from './Recipe';

export type SegmentIngredient = {
	quantityText: null | string;
	quantity: null | number;
	maxQuantity: null | number;
	unit: null | string;
	unitId: null | string;
	additionBefore: null | string;
	ingredient: null | string;
	ingredientId: null | string;
	additionAfter: null | string;
	isFluid: boolean | null;
	scalingFactor: number | null;
	status: SegmentStatus;
	type: IngredientType;
	errorMessages: string[];
	errorActions: string[];
	productId: string | null;
	productNutrients: {
		[key: string]: number;
	};
};

export const mapIngredientToAPIIngredient = (
	input: {
		index: number;
		segmentIngredient: SegmentIngredient;
		ingredients?: IngredientList.Type;
	},
	incorporationShares: (IncorporationShare & { index: number })[]
): apiPostRecipeCalculateV1.Ingredients => {
	const share = Optional.Maybe(incorporationShares.find((y) => y.ingredientIndex === input.index))
		.map<number | null>((e) => e.incorporationShare)
		.getOrDefault(null);

	const product = IngredientList.getSelectedProduct(
		input.ingredients ?? [],
		input.index,
		input.segmentIngredient.ingredientId ?? ''
	);

	let productValues = undefined;
	if (product) {
		productValues = {
			price: product?.price ?? 0,
			calories: product?.nutrients['fe3a239d-a8d6-4478-b8ed-e467d732057c'] ?? 0,
			carbonMonoxide: 0,
			nutrientValues: product?.nutrients ?? {},
		};
	}

	const incorporationShare = incorporationShares.find(
		(y) => y.ingredientId === input.segmentIngredient.ingredientId
	);

	return {
		ingredientIndex: input.index,
		incorporationShare: share,
		ingredientId: input.segmentIngredient.ingredientId!,
		maxQuantity: input.segmentIngredient.maxQuantity,
		quantity: input.segmentIngredient.quantity,
		unitId: input.segmentIngredient.unitId,
		productValues: productValues,
		relevanceType: incorporationShare?.relevanceType || relevanceType.Irrelevant,
	};
};

export const mapAccessoryToAPIAccessory = (x: {
	index: number;
	segmentIngredient: SegmentIngredient;
}): apiPostRecipeCalculateV1.Accessories => {
	return {
		accessoryIndex: x.index,
		accessoryId: x.segmentIngredient.ingredientId!,
		maxQuantity: x.segmentIngredient.maxQuantity,
		quantity: x.segmentIngredient.quantity,
		unitId: x.segmentIngredient.unitId,
	};
};
